export const INDICATOR_TEXT = {
  TITLE_ACCOUNT: 'Tài khoản',
  LOGOUT: 'Đăng xuất',
  ADD_TO_CART_SUCCESS: 'Thêm vào giỏ hàng thành công',
  VIEW_CART: 'Xem giỏ hàng',
};
